import { Utility } from './../../../shared/utility';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-record-detail-view',
  templateUrl: './record-detail-view.component.html',
  styleUrls: ['./record-detail-view.component.css']
})
export class RecordDetailViewComponent implements OnInit {
  recordIssues: any;
  recordErrors: any;
  isErr = false;
  isIssue = false;
  recordDetailDialog = false;
  selectedRecord: any;

  @Input() set adjRecordDetail(adjRecord) {
    if (adjRecord) {
      this.openRecordDetail(adjRecord);
    }
  }
  @Output() isCancelClicked = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
  }

  openRecordDetail(record: any): void {
    this.recordIssues = [];
    this.recordErrors = [];
    this.isErr = false;
    this.isIssue = false;
    if (record && record.error) {
      this.isErr = true;
      this.recordErrors = record.error.split(',');
    }
    if (record && record.issue) {
      this.isIssue = true;
      const issues = record.issue.split(',');
      this.recordIssues = Utility.getIssues(issues);
    }
    this.selectedRecord = record;
    this.recordDetailDialog = true;
  }

  closeDetailDialog() {
    this.isCancelClicked.emit(false);
    this.recordDetailDialog = false;
  }

}
